import { render, staticRenderFns } from "./CompanySetting.vue?vue&type=template&id=4f6f9190&scoped=true&"
import script from "./CompanySetting.vue?vue&type=script&lang=js&"
export * from "./CompanySetting.vue?vue&type=script&lang=js&"
import style0 from "./CompanySetting.vue?vue&type=style&index=0&id=4f6f9190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6f9190",
  null
  
)

export default component.exports